import { Box, Text, Flex } from "@fluentui/react-northstar";

const CustomFieldsBox = ({ icon = null, header, info, changeChartType }) => {
  return (
    <Box
      styles={{
        border: "1px solid #f2f2f2",
        padding: "5px",
      }}
      onClick={changeChartType}
    >
      <Flex >
        <Box className="left-section">
          <div
            style={{
              backgroundColor: "#f2f2f2",
              minHeight: "26px",
            }}
          ></div>
          {Object.keys(info).map((key, i) => (
            <Flex
              key={`${key}-${i}`}
              hAlign="end"
              gap="gap.smaller"
              style={{ padding: "2px 5px" }}
            >
              <Text content={key.toUpperCase()} truncated title={key} />
              {icon}
            </Flex>
          ))}
        </Box>
        <Box className="right-section">
          <div style={{ backgroundColor: "#f2f2f2", padding: "2px 5px" }}>
            <Text content={header.toUpperCase()} weight="semibold" />
          </div>
          {Object.values(info).map((value, i) => (
            <Flex
              key={`${i}-${header}`}
              hAlign="end"
              style={{ padding: "2px 5px" }}
            >
              <Text content={value} title={value} />
            </Flex>
          ))}
        </Box>
      </Flex>
    </Box>
  );
};

export default CustomFieldsBox;
